import { post } from '@/utils/request'

const ANON_KEY = 'anon_id'

function getAnonId(): string {
  if (typeof window === 'undefined') return ''
  try {
    let id = window.localStorage.getItem(ANON_KEY)
    if (!id) {
      id =
        (typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`
      window.localStorage.setItem(ANON_KEY, id)
    }
    return id
  } catch {
    return ''
  }
}

// 第一方埋点：fire-and-forget，永不阻塞 UI、永不抛错。
// eslint-disable-next-line import/prefer-default-export
export function track(name: string, props: Record<string, any> = {}): void {
  if (typeof window === 'undefined') return
  const { target, value, ...metadata } = props
  const payload = {
    name,
    target,
    value,
    path: window.location.pathname,
    anon_id: getAnonId(),
    metadata,
  }
  try {
    Promise.resolve(post('events', payload)).catch(() => {})
  } catch {
    /* noop */
  }
}
